"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'tools.galleryTags.name': '图库标签',
    'tools.galleryTags.description': '使用标签管理和组织图库内容',
};
